import { render, staticRenderFns } from "./CertificateAccess.vue?vue&type=template&id=791b91d7"
import script from "./CertificateAccess.vue?vue&type=script&lang=js"
export * from "./CertificateAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports